import {
  TAB_ONE,
  TAB_THREE,
  TAB_TWO,
  TAB_FOUR,
  TAB_FIVE,
  TAB_SIX,
} from "../constants/constants"
import { generateFirestoreId } from "./nanoidUtils"

export const createDefaultSettings = () => {
  return []
}

export const createDefaultNoteTabs = () => {
  const noteArray = [
    {
      abbr: "Sub",
      label: "Subjective",
      id: generateFirestoreId(),
      uid: generateFirestoreId(),
      key: generateFirestoreId(),

      docId: generateFirestoreId(),

      noteId: TAB_ONE,
      postureTab: false,
      orderIndex: 0,
    },
    {
      abbr: "Obj",
      label: "Objective",
      id: generateFirestoreId(),
      uid: generateFirestoreId(),
      key: generateFirestoreId(),

      docId: generateFirestoreId(),

      orderIndex: 1,
      postureTab: false,
      noteId: TAB_TWO,
    },
    {
      abbr: "Assess",
      label: "Assessment",
      id: generateFirestoreId(),
      uid: generateFirestoreId(),
      key: generateFirestoreId(),

      docId: generateFirestoreId(),

      noteId: TAB_THREE,
      orderIndex: 2,
      postureTab: false,
    },
    {
      abbr: "Plan",
      label: "Plan",
      id: generateFirestoreId(),
      uid: generateFirestoreId(),
      noteId: TAB_FOUR,
      key: generateFirestoreId(),

      docId: generateFirestoreId(),

      orderIndex: 3,
      postureTab: false,
    },
    {
      abbr: "Posture",
      label: "Postural Assessment",
      id: generateFirestoreId(),
      uid: generateFirestoreId(),
      noteId: TAB_SIX,

      key: generateFirestoreId(),

      docId: generateFirestoreId(),

      postureTab: true,
      orderIndex: 5,
    },
    {
      abbr: "Custom",
      label: "Customise In Settings",
      id: generateFirestoreId(),
      uid: generateFirestoreId(),
      key: generateFirestoreId(),

      docId: generateFirestoreId(),
      noteId: TAB_FIVE,

      postureTab: false,
      orderIndex: 4,
    },
  ]

  return noteArray
}
